/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { REPAYMENT_CONFIG_URL } from "../../../../../api/api_routing_urls";
import useAuth from "../../../../../authentication/hooks/useAuth";
import useAxiosPrivate from "../../../../../authentication/hooks/useAxiosPrivate";
import Button from "../../../../../reusable-components/buttons/Button";
import SubmitButton from "../../../../../reusable-components/buttons/SubmitButton";
import Dropdown from "../../../../../reusable-components/inputs/Dropdowns/Dropdown";
import TextArea from "../../../../../reusable-components/inputs/InputTextAreas/TextArea";
import Input from "../../../../../reusable-components/inputs/InputTextBox/Input";
import { button, cancel_button } from "../../../../../theme/lightTheme";
import { rePaymentFormModeDD } from "../../../../../utilities/constants/constants";
import { formatINRCurrency } from "../../../../../utilities/currency/currency";
import {
  getFormattedDateDDMMMYYYYDate,
  getFormattedDateInputDate,
} from "../../../../../utilities/dateFunctions/formatdate";
import showToast from "../../../../../utilities/notification/NotificationModal";
import LabelWithDetail from "./LabelWithDetail";
import GenericModal from "../../../../../reusable-components/modals/GenericModal";
import ReceiptList from "../../../ReportsList/Ledger/ReceiptList";
import PrintReceipt from "../../../ReportsList/Ledger/ViewReceipt";
import Receipt_In_Add_Repayment from "../../../ReportsList/Ledger/Receipt_In_Add_Repayment";

const AddRepaymentForm = ({
  principleDueWithIntData,
  repaymentDateChangeHandler,
  setSpecficDate,
  repaymentDate,
  currentDateFromServer,
  setAddRepayment,
  maximumPayAmount,
  addRepaymentDetails,
  specficDate,
  principlePaidAmount,
  interestPaidAmount,
  getInitialLoadCalculation,
  setRepaymentAmount,
  setRefreshPage,
  totalDueAmount,
  penalTotalDue,
  ioiTotalDue,
  loaneeTotalRepaymentAmt,
  repaymentAmount,
}) => {
  const axiosPrivate = useAxiosPrivate();
  const { auth } = useAuth();

  const [selectedRepaymentMode, setSelectedRepaymentMode] = useState();
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState(null); // New state variable for form data

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setError,
    clearErrors,
    reset,
    setValue,
    control,
  } = useForm({
    mode: "onChange",
    defaultValues: principleDueWithIntData,
    criteriaMode: "all",
    shouldFocusError: true,
    shouldUnregister: true,
  });

  const controller = new AbortController();

  const handleFormSubmit = (data) => {
    if (+data?.repaymentamount <= +maximumPayAmount) {
      setFormData(data); // Store form data
      setShowModal(true); // Open modal
    } else {
      showToast(
        "Whoops!!!! This doesn't feel right. There might be an issue. Please contact administrator",
        "error"
      );
    }
  };

  const onSubmit = async () => {
    try {
      let response = "";
      response = await axiosPrivate.post(
        `${REPAYMENT_CONFIG_URL}/repyamentLedger`,
        {
          loan_number: addRepaymentDetails?.loan_number,
          paymentmode: formData?.paymentmode?.value,
          repayment_date: specficDate || currentDateFromServer,
          principle_paid: principlePaidAmount,
          interest_paid: interestPaidAmount,
          chequeno: formData?.chequeno,
          transectionid: formData?.transectionid,
          particulars: formData?.particulars,
          createdby: auth.userid,
          interest_debit: +principleDueWithIntData?.interest_debit,
          cheque_date: formData?.chequedate,
        },
        {
          signal: controller.signal,
        }
      );

      if (response.status === 200) {
        showToast("Repayment detail has been added successfully", "success");

        getInitialLoadCalculation();

        setRepaymentAmount(0);
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact administrator",
          "error"
        );

        return;
      }
      reset();
      setAddRepayment(false);
    } catch (error) {
      if (!error?.response) {
        showToast("No Server Response", "error");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact administrator",
          "error"
        );
      }
    } finally {
      setRefreshPage((prev) => !prev);
      setShowModal(false); // Close modal after submission
    }
  };

  const [specificChequeDate, setSpecificChequeDate] = useState();

  useEffect(() => {
    try {
      setRepaymentAmount(null);
    } catch (error) {
      console.error(error);
    }
  }, [repaymentDate]);

  return (
    <>
      <section>
        <form onSubmit={handleSubmit(handleFormSubmit)}>
          <div className="grid grid-cols-3 gap-x-3 ">
            <fieldset className="col-span-3  p-2 bg-slate-100 border grid grid-cols-1 md:grid-cols-3 gap-x-3 mt-2">
              <legend className="px-2 ml-3 bg-slate-700 rounded-sm text-white text-sm p-1">
                Repayment
              </legend>
              <Input
                defaultName="repaymentdate"
                register={register}
                name="Repayment Date"
                required={true}
                pattern={null}
                errors={errors}
                setError={setError}
                clearError={clearErrors}
                autoComplete="off"
                type="date"
                classes={`rounded-sm px-3 py-2 text-sm w-full`}
                onChangeInput={(e) => {
                  repaymentDateChangeHandler(e);
                  if (
                    getFormattedDateInputDate(e) >=
                    getFormattedDateInputDate(
                      principleDueWithIntData?.last_repaymentdate
                    )
                  ) {
                    setSpecficDate(e);
                  } else {
                    setError("repaymentdate", {
                      type: "required",
                      message: `Repayment date is invalid`,
                    });
                  }
                }}
                defaultValue={repaymentDate || currentDateFromServer}
                setValue={setValue}
                min={getFormattedDateInputDate(
                  principleDueWithIntData?.last_repaymentdate
                )}
                max={getFormattedDateInputDate(
                  principleDueWithIntData?.currentdate
                )}
              />
              <Input
                defaultName="repaymentamount"
                register={register}
                name="Repayment Amount"
                required={true}
                pattern={null}
                errors={errors}
                placeholder="Enter repayment amount"
                setError={setError}
                clearError={clearErrors}
                autoComplete="off"
                type="number"
                classes={`rounded-sm px-3 py-2 text-sm w-full`}
                onChangeInput={(e) => {
                  setRepaymentAmount(e);
                }}
                defaultValue={repaymentAmount}
                setValue={setValue}
                max={maximumPayAmount}
              />

              <Dropdown
                defaultName="paymentmode"
                register={register}
                labelname="Payment Mode"
                required={true}
                pattern={null}
                errors={errors}
                classes={`rounded-sm text-sm w-full`}
                setError={setError}
                clearError={clearErrors}
                onChangeInput={null}
                control={control}
                data={rePaymentFormModeDD}
                defaultValue={principleDueWithIntData?.paymentmode}
                setValue={setValue}
                setSelected={setSelectedRepaymentMode}
                selected={selectedRepaymentMode}
                maxMenuHeight={120}
              />
            </fieldset>
            <fieldset className="col-span-3 px-2 grid grid-cols-1 md:grid-cols-3 gap-x-3 text-sm my-3 text-slate-800 ">
              <legend className="text-slate-700 text-sm underline underline-offset-2">
                Adjustment
              </legend>
              <LabelWithDetail
                label="Principle Amount Pay"
                value={formatINRCurrency(principlePaidAmount)}
                pill={true}
              />
              <LabelWithDetail
                label="Interest Amount Pay"
                value={formatINRCurrency(interestPaidAmount)}
                pill={true}
              />
            </fieldset>
            <fieldset className="col-span-3 px-2 grid grid-cols-1 md:grid-cols-3 gap-x-3 text-sm my-3 ">
              <legend className="text-slate-700  text-sm  underline underline-offset-2">
                Other details
              </legend>
              <TextArea
                defaultName="particulars"
                register={register}
                name="Particulars"
                required={false}
                pattern={null}
                errors={errors}
                placeholder="Enter particulars"
                setError={setError}
                clearError={clearErrors}
                autoComplete="off"
                type="text"
                classes={`rounded-sm px-3 py-2 text-sm w-full resize-none `}
                onChangeInput={null}
                defaultValue={principleDueWithIntData?.particulars}
                setValue={setValue}
              />
              <Input
                defaultName="chequeno"
                register={register}
                name="Cheque No"
                required={false}
                pattern={null}
                errors={errors}
                placeholder="Enter cheque no"
                setError={setError}
                clearError={clearErrors}
                autoComplete="off"
                type="text"
                classes={`rounded-sm px-3 py-2 text-sm w-full`}
                onChangeInput={null}
                defaultValue={principleDueWithIntData?.chequeno}
                setValue={setValue}
              />
              {/* <Input
                defaultName="transectionid"
                register={register}
                name="Transaction Id"
                required={false}
                pattern={null}
                errors={errors}
                placeholder="Enter transaction id"
                setError={setError}
                clearError={clearErrors}
                autoComplete="off"
                type="text"
                classes={`rounded-sm px-3 py-2 text-sm w-full`}
                onChangeInput={null}
                defaultValue={principleDueWithIntData?.transectionid}
                setValue={setValue}
              /> */}

              <Input
                defaultName="chequedate"
                register={register}
                name="Cheque Date"
                required={null}
                pattern={null}
                errors={errors}
                setError={setError}
                clearError={clearErrors}
                autoComplete="off"
                type="date"
                classes={`rounded-sm px-3 py-2 text-sm w-full`}
                onChangeInput={(e) => {
                  setSpecificChequeDate(e);
                }}
                defaultValue={currentDateFromServer}
                setValue={setValue}
                // min={getFormattedDateInputDate(
                //   principleDueWithIntData?.last_repaymentdate
                // )}
                // max={getFormattedDateInputDate(
                //   principleDueWithIntData?.currentdate
                // )}
              />
            </fieldset>
          </div>
          <div className="flex justify-between mt-6">
            <SubmitButton
              isSubmitting={isSubmitting}
              label={"Submit"}
              className={button}
            />
            <Button
              onClick={() => {
                setAddRepayment(false);
              }}
              aria-label="Cancel District Update Button"
              className={cancel_button}
            >
              Cancel
            </Button>
          </div>
        </form>
      </section>

      <GenericModal
        open={showModal}
        setOpen={setShowModal}
        title={"Repayment Details"}
        isLarge={true}
        isAdd={false}
      >
        <Receipt_In_Add_Repayment
          principleDueWithIntData={principleDueWithIntData}
          addRepaymentDetails={addRepaymentDetails}
          totalDueAmount={totalDueAmount}
          formData={formData}
          penalTotalDue={penalTotalDue}
          ioiTotalDue={ioiTotalDue}
          loaneeTotalRepaymentAmt={loaneeTotalRepaymentAmt}
        />

        <div className="flex justify-end mt-6 gap-x-6">
          <SubmitButton
            isSubmitting={isSubmitting}
            label={"Confirm"}
            className={button}
            onClick={onSubmit}
          />
          <Button
            onClick={() => {
              setShowModal(false);
            }}
            aria-label="Cancel Modal Button"
            className={cancel_button}
          >
            Cancel
          </Button>
        </div>
      </GenericModal>
    </>
  );
};

export default AddRepaymentForm;
